import type { ElementType, RefObject } from 'react';
import { createSafeContext } from '@lib/utils';

export interface SidebarMenuContextValue {
  linkComponent: ElementType;
  onSelect?: (id: string) => void;
  activeId?: string;
  /** Called when item is clicked on mobile to close sidebar */
  onMobileClose?: () => void;
  /** Whether we're on mobile breakpoint */
  isMobile?: boolean;
  /** Ref to the scrollable container for auto-scroll feature */
  scrollContainerRef?: RefObject<HTMLDivElement | null>;
}

export const [SidebarMenuProvider, useSidebarMenu] = createSafeContext<SidebarMenuContextValue>(
  'SidebarMenu component was not found in tree'
);
